
import {
  HollowDotsSpinner,
  SpringSpinner,
  LoopingRhombusesSpinner,
  FulfillingSquareSpinner,
  FulfillingBouncingCircleSpinner,
} from "epic-spinners";

export default {
  name: "ShowSpinners",
  components: {
    HollowDotsSpinner,
    SpringSpinner,
    LoopingRhombusesSpinner,
    FulfillingSquareSpinner,
    FulfillingBouncingCircleSpinner,
  },
  props: {
    type: { default: "spring", type: String },
    size: { default: 15, type: Number },
    color: { default: "#db3d32", type: String },
  },
};
